"use strict";

class DeveloperRolesController {

    constructor($scope, SSHttpService, SSAlertService, SSUserService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;

        self.SSHttpService = SSHttpService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;
        self.role_id = null;

        self.has_access = false;
        if (self.SSUserService.isDeveloper()
            && self.SSUserService.hasPermission('DMS_ROLES_VIEW')
        ) {
            self.init();
            self.has_access = true;
        }
    }

    init() {
        let self = this;

        self.roles = null;

        self.user = self.SSUserService.getUser();

        self.getRolesData();
        self.getDeveloperProfile();
    }

    getDeveloperProfile() {
        const self = this;

        self.developer = null;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developer = response.data.developer;

        });
    }

    getRolesData() {
        let self = this;

        //let url = 'sec/developer/' + self.user.id + '/roles';
        let url = 'sec/developer/roles';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.roles = response.data.developer_roles;
        });
    }

    addUpdateRole(role) {
        const self = this;

        self.roleParams = {};
        self.roleErrors = {};

        if (role) {
            self.roleParams = role;
        }

        self.rolesUpdateModal = true;
        jQuery('#rolesUpdateModal').modal('show');
    }

    saveRole() {
        const self = this;

        // Validate input fields
        if (!self.isValidRoleInput()) {
            return;
        }

        jQuery('#rolesUpdateModal').modal('hide');

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to ' + (self.roleParams.id ? 'update' : 'create') + ' this role?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {

                self.roleErrors = {};

                //let url = 'sec/developer/' + self.user.id + '/roles';
                let url = 'sec/developer/roles';

                // In case of new role creation, don't pass 'permissions' param
                // In case of edit role, pass 'permissions' which are already assigned to role
                let params = self.roleParams;

                params.name = params.display_name.replace(/ /g, "_");
                params.name = 'DEV_' + self.developer.id + '_' + params.name;

                let responseHandler = function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        setTimeout(function () {
                            jQuery('#rolesUpdateModal').modal('show');
                        }, 500);
                        self.SSAlertService.parseAndDisplayError(response);
                        self.roleErrors.display_name = response.message;
                        return;
                    }

                    self.SSAlertService.success('Success!', 'Role updated successfully.');
                    self.getRolesData();

                    // try{
                    //     // angular.merge is not working as roles data in response is different 
                    //     angular.merge(self.roles, response.data);
                    // }
                    // catch(ex){
                    //     console.log(ex);
                    // }
                };

                loading(true);
                if (self.roleParams.id) {
                    url += '/' + self.roleParams.id;
                    self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
                } else {
                    self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
                }
            }
        );
    }

    isValidRoleInput() {
        const self = this;

        let isValid = true;
        let regEx = /^[a-zA-Z0-9_ ]+$/;

        self.roleErrors = {};

        // if (!self.roleParams.name) {
        //     self.roleErrors.name = 'Code is required';
        //     isValid = false;
        // }
        if (!self.roleParams.display_name) {
            self.roleErrors.display_name = 'Display Name is required';
            isValid = false;
        }

        if (self.roleParams.description && self.roleParams.description.length > 255) {
            self.roleErrors.description = 'Description is maximum 255 characters';
            isValid = false;
        }

        if (self.roleParams.display_name != '' && !regEx.test(self.roleParams.display_name)) {
            self.roleErrors.display_name = 'Only alphabets, numbers, spaces and underscore are allowed';
            isValid = false;
        }

        return isValid;
    }

    removeRole(role) {
        const self = this;

        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this role?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                //let url = 'sec/developer/' + self.user.id + '/roles/' + role.id +'/delete';
                let url = 'sec/developer/roles/' + role.id + '/delete';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    self.roles = $.grep(self.roles, function (obj) {
                        return obj.id != role.id;
                    });
                    self.SSAlertService.success('Success!', 'Role deleted successfully.');
                });
            }
        );
    }

}

DeveloperRolesController.$inject = ['$scope', 'SSHttpService', 'SSAlertService', 'SSUserService', 'SSConfirmationService'];
app.controller('DeveloperRolesController', DeveloperRolesController);

